import { useState } from "react";
import emailjs from "@emailjs/browser";

const useWaitlistModal = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formError, setFormError] = useState("");

  const openWaitlistModal = () => {
    setShowWaitlistModal(true);
    setIsSubmitted(false);
    setFormError("");
    setFormData({ name: "", email: "", company: "" });
  };

  const closeWaitlistModal = () => {
    setShowWaitlistModal(false);
    setIsSubmitted(false);
    setFormError("");
    setFormData({ name: "", email: "", company: "" });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim() || !formData.email.trim()) {
      setFormError("Please complete all required fields before submitting.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setFormError("Please enter a valid work email.");
      return;
    }

    setIsSubmitting(true);

    try {
      const formUrl =
        "https://docs.google.com/forms/d/e/1FAIpQLScXalFmSYJoGCmDPYyZB5YpDCWfz7mcF60zk5tvdqvmdDYFVw/formResponse";

      const formDataToSubmit = new FormData();
      formDataToSubmit.append("emailAddress", formData.email);
      formDataToSubmit.append("entry.1769034968", formData.name);
      formDataToSubmit.append("entry.2022145951", formData.email);
      formDataToSubmit.append("entry.289584164", formData.company);

      const googleFormSubmit = fetch(formUrl, {
        method: "POST",
        body: formDataToSubmit,
        mode: "no-cors",
      });

      const emailParams = {
        to_email: "contact@jindolabs.com",
        from_name: formData.name,
        from_email: formData.email,
        company: formData.company || "Not provided",
        message: `New waitlist submission:\n\nName: ${formData.name}\nEmail: ${formData.email}\nCompany: ${formData.company || "Not provided"}`,
      };

      const emailSubmit = emailjs
        .send(
          "service_sn7gcw7",
          "template_uurx41h",
          emailParams,
          "tJGYjukH0xBnE098U"
        )
        .catch((error) => {
          console.error("Email notification failed:", error);
        });

      await Promise.all([googleFormSubmit, emailSubmit]);

      setIsSubmitted(true);
    } catch (error) {
      console.error("Error submitting form:", error);
      setIsSubmitted(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    showWaitlistModal,
    formData,
    isSubmitting,
    isSubmitted,
    formError,
    openWaitlistModal,
    closeWaitlistModal,
    handleInputChange,
    handleSubmit,
  };
};

export default useWaitlistModal;
